import { sha256 } from '@noble/hashes/sha2.js';
import { utf8ToBytes } from '@noble/hashes/utils.js';
/**
 * Encode exactly 6 bytes as unpadded base64url (8 characters).
 */
function bytesToBase64Url6(bytes) {
    let binary = '';
    for (let i = 0; i < 6; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    const b64 = globalThis.btoa(binary);
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
/**
 * Canonical 8-character URL segment for a node id: first 6 bytes of SHA-256(nodeId),
 * UTF-8 encoded, as unpadded base64url.
 */
export function shortNodeKey(nodeId) {
    const hash = sha256(utf8ToBytes(nodeId));
    return bytesToBase64Url6(hash.subarray(0, 6));
}
/**
 * Find a node whose id equals the URL segment, or whose shortNodeKey(id) equals the segment.
 */
export function resolveNodeByUrlKey(nodes, urlSegment) {
    if (!urlSegment) {
        return null;
    }
    for (const node of nodes) {
        if (node.id === urlSegment) {
            return node;
        }
    }
    for (const node of nodes) {
        if (shortNodeKey(node.id) === urlSegment) {
            return node;
        }
    }
    return null;
}
